module.exports = __webpack_public_path__ + "static/media/AIRoboto_logo_1.eee81644.png";